// extracted by mini-css-extract-plugin
export default {"products":"RA-z","card":"SA-z","oosMessaging":"TA-z"};